// @ts-check
import React, { useRef } from "react"
import { TableHead } from "./head/TableHead.component"
import { TableBody } from "./body/TableBody.component"
import { TableFoot } from "./foot/TableFoot.component"

/**
 * @param {import("./Table.component.types").TableProps} props
 */
export const Table = (props) => {
  const {
    table,
    estimatedRowHeight,
    isLoading = false,
    emptyMessage,
    className,
    enableStickyGroupHeaders = false,
    getIsRowSticky,
    onContextMenu,
    rowClassName,
    infiniteScroll,
  } = props

  const isEmpty = table.getRowModel().rows.length === 0

  const tableRef = useRef(null)

  return (
    <div className="table" ref={tableRef}>
      <table className={`table__inner ${className || ""}`}>
        <TableHead table={table} />
        <TableBody
          table={table}
          tableRef={tableRef}
          estimateSize={estimatedRowHeight}
          isLoading={isLoading}
          isEmpty={isEmpty}
          emptyMessage={emptyMessage}
          enableStickyGroupHeaders={enableStickyGroupHeaders}
          getIsRowSticky={getIsRowSticky}
          onContextMenu={onContextMenu}
          rowClassName={rowClassName}
          infiniteScroll={infiniteScroll}
        />
        {isLoading || isEmpty ? null : <TableFoot table={table} />}
      </table>
    </div>
  )
}
